import React from 'react';
import { FileText, FileCode, Gamepad2 } from 'lucide-react';

const iconMap = {
  'txt': FileText,
  'md': FileCode,
  'game': Gamepad2,
};

export const DesktopIcon = ({ name, type, onDoubleClick, isSelected = false }) => {
  const Icon = iconMap[type] || FileText;

  return (
    <button
      className={`
        desktop-icon flex flex-col items-center justify-center gap-1 p-2 w-20
        rounded-sm cursor-pointer select-none
        ${isSelected ? 'bg-primary/20 ring-1 ring-primary/50' : ''}
      `}
      onDoubleClick={onDoubleClick}
    >
      {/* Icon */}
      <div className="relative">
        <Icon className="w-10 h-10 text-primary text-glow-subtle" strokeWidth={1.5} />
        {type === 'game' && (
          <div className="absolute -bottom-1 -right-1 text-xs">🐧</div>
        )}
      </div>
      
      {/* Label */}
      <span className="text-primary text-xs text-center leading-tight text-glow-subtle truncate w-full">
        {name}
      </span>
    </button>
  );
};
